import { customerIoClient } from "@trueskin-web/apis"
import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import Accordion from "./accordion"

const FAQs = ({ items = [] }) => {
  return (
    <div data-testid="web-portal-plan-selection-faqs">
      <Heading
        as="h3"
        mt={6}
        mb={4}
        sx={{
          fontFamily: "display",
          lineHeight: "body",
          textAlign: [null, "center"],
        }}
      >
        <Trans i18nKey="ChoosePlan.Faqs.title" />
      </Heading>
      {items.map(({ icon, question, answer }, index) => (
        <Accordion
          key={index}
          icon={icon}
          title={question}
          onExpand={() => {
            customerIoClient.track(customerIoClient.EVENT_NAMES.FAQ_EXPANDED)
          }}
        >
          {answer}
        </Accordion>
      ))}
    </div>
  )
}

export default FAQs
